import {
    GeneralAppState,
    initialGeneralAppState,
} from './general/GeneralAppState';
import { OrdersState, initialOrdersState } from './orders/OrdersState';
import { CurrencyState } from 'app/currencies/store/CurrencyState';
import { initialCurrencyState } from 'app/currencies/store/reducer';
import { AppSettingsState } from './appSettings/AppSettingsState';
import { initialAppSettingsState } from './appSettings/AppSettingsState';
import { ShareUsersState } from './shareUsers/ShareUsersState';
import {
    FeatureTogglesState,
    initialFeatureTogglesState,
} from './featureToggles/FeatureTogglesState';
import {
    ConnectivityState,
    initialConnectivityState,
} from 'app/store/connectivity/ConnectivityState';

export const initialAppState: AppState = {
    appSettings: initialAppSettingsState,
    connectivity: initialConnectivityState,
    currencies: initialCurrencyState,
    featureToggles: initialFeatureTogglesState,
    general: initialGeneralAppState,
    orders: initialOrdersState,
    shareUsers: [],
};

export interface AppState {
    appSettings: AppSettingsState;
    connectivity: ConnectivityState;
    currencies: CurrencyState;
    featureToggles: FeatureTogglesState;
    general: GeneralAppState;
    orders: OrdersState;
    shareUsers: ShareUsersState;
}
